export enum ErrorEnum {
    F_EXCEPTION_ESTABLISHMENT_NOT_FOUND = '30201'
}
